import React from 'react';
import { Form as SemanticForm } from 'semantic-ui-react';
import { FormFieldProp } from '../../../enum/apiResultProp/FormFieldProp';

export default ({ fieldProps, onValueChange, onInputBlur }) => {
    const value = fieldProps[FormFieldProp.Value];
    const placeholder = fieldProps[FormFieldProp.Placeholder];
    const showLabel = fieldProps[FormFieldProp.ShowLabel];
    const label = fieldProps[FormFieldProp.Label];
    const hasError = fieldProps[FormFieldProp.HasError];
    const showMandatorySign = fieldProps[FormFieldProp.ShowMandatorySign];
    const isReadOnly = fieldProps[FormFieldProp.IsReadOnly];

    let textFieldProps = {
        type: 'text',
        required: showMandatorySign,
        readOnly: isReadOnly,
        disabled: isReadOnly,
        error: hasError,
        placeholder: placeholder,
        value: value,
        onChange: (e) => onValueChange({ value: e.target.value }),
        onBlur: () => onInputBlur({ value: value })
    };
    if (showLabel) {
        textFieldProps = { ...textFieldProps, label: label };
    }

    return <SemanticForm.Input {...textFieldProps} />;
}